module.exports = {
	"elementName": "ObjectSchema",
	"name": "Titles",
	"containers": [
		{
			"name": "container",
			"elementName": "Container",
			"style": {
				"top": 0,
				"left": 0,
				"width": 380,
				"height": 400,
				"position": "relative"
			},
			"props": {},
			"boxes": [
				{
					"name": "BigTitle",
					"elementName": "Core.TextContent",
					"style": {
						"top": 0,
						"left": 0
					},
					"props": {
						"content": "Big Title",
						"font": {
							"fontSize": 30
						}
					},
					"bindings": {}
				},
				{
					"name": "SmallTitle",
					"elementName": "Core.TextContent",
					"style": {
						"top": 80,
						"left": 0
					},
					"props": {
						"content": "Small Title",
						"font": {
							"fontSize": 20
						}
					},
					"bindings": {}
				},
				{
					"name": "MiddleTitle",
					"elementName": "Core.TextContent",
					"style": {
						"top": 40,
						"left": 0
					},
					"props": {
						"content": "Middle Title",
						"font": {
							"fontSize": 24
						}
					},
					"bindings": {}
				},
				{
					"name": "SmartTitle",
					"elementName": "Core.TextContent",
					"style": {
						"top": 120,
						"left": 0
					},
					"props": {
						"content": "Smart Title",
						"font": {
							"fontFamily": "Lobster",
							"fontSize": 24
						}
					},
					"bindings": {}
				},
				{
					"name": "HandwrittingTitle",
					"elementName": "Core.TextContent",
					"style": {
						"top": 160,
						"left": 0
					},
					"props": {
						"content": "Handwritting Title",
						"font": {
							"fontFamily": "Courgette",
							"fontSize": 24,
							"bold": false
						}
					},
					"bindings": {}
				},
				{
					"name": "FormalTitle",
					"elementName": "Core.TextContent",
					"style": {
						"top": 200,
						"left": 0
					},
					"props": {
						"content": "Formal Title",
						"font": {
							"fontFamily": "Open Sans",
							"fontSize": 24
						}
					},
					"bindings": {}
				},
				{
					"name": "IndieTitle",
					"elementName": "Core.TextContent",
					"style": {
						"top": 280,
						"left": 0
					},
					"props": {
						"content": "Indie Title",
						"font": {
							"fontFamily": "Indie Flower",
							"fontSize": 28
						}
					},
					"bindings": {}
				},
				{
					"name": "HistoricalTitle",
					"elementName": "Core.TextContent",
					"style": {
						"top": 240,
						"left": 0
					},
					"props": {
						"content": "Historical Title",
						"font": {
							"fontFamily": "Great Vibes",
							"fontSize": 28,
							"bold": false
						}
					},
					"bindings": {}
				},
				{
					"name": "PoiretTitle",
					"elementName": "Core.TextContent",
					"style": {
						"top": 320,
						"left": 0
					},
					"props": {
						"content": "Poiret Title",
						"font": {
							"fontFamily": "Poiret One",
							"fontSize": 28,
							"bold": true
						}
					},
					"bindings": {}
				},
				{
					"name": "ColorTitle",
					"elementName": "Core.TextContent",
					"style": {
						"top": 360,
						"left": 0
					},
					"props": {
						"content": "Color Title",
						"font": {
							"fontFamily": "Arial",
							"fontSize": 24,
							"bold": false,
							"color": {
								"color": "#fa3e0a",
								"hsv": {
									"h": 13.09090909090909,
									"s": 96,
									"v": 98
								},
								"alpha": 100
							}
						}
					},
					"bindings": {}
				}
			],
			"containers": []
		}
	],
	"props": {
		"context": {}
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/toolbox/templates/TextTitles.json
 ** module id = 971
 ** module chunks = 0
 **/